import { useBienContext } from '../BienContext'

import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { Input, Textarea, Toggle } from '@/components/ui'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'equipements'
  const SECTION_TITLE = "Equipements"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les équipements"
  />

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        { bien.type_bien !== 'immeuble' && <Input.Display label="Cuisine" value={bien.cuisine} valueClassName="uppercase"/> }
        <Input.Display label="Climatisation" value={bien.climatisation} valueClassName="uppercase" />
        <Input.Display label="Chauffage" value={bien.chauffage} valueClassName="uppercase" />
        <Input.Display label="Ascenseur" value={bien.ascenseur} valueClassName="uppercase" />
        <Input.Display label="Menuiserie" value={bien.menuiserie} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Eau chaude" value={bien.eau_chaude} valueClassName="uppercase" />
        <Input.Display label="Eaux usées" value={bien.eaux_usees} valueClassName="uppercase" />
        <Input.Display label="Internet" value={bien.internet} valueClassName="uppercase" />
        <Toggle.Display label="Détecteur de fumée" value={bien.detecteur_fumee || false} />
      </div>
      <div className="space-y-4">
        <Input.Display label="Ventilation" value={bien.ventilation} valueClassName="uppercase" />
        <Input.Display label="Isolation" value={bien.isolation} valueClassName="uppercase" />
        <Textarea.Display 
          label="Autres (alarme, accès PMR, interphone, vidéosurveillance, adoucisseur, domotique)" 
          value={bien.autres_equipements} />
      </div>

    </DetailTemplate>
  )
}